import { createClient, type Client, type ClientOptions, type TokenProvider } from '../engine/api/client';

// The portal talks to its OWN route group: /portal/auth/* and /portal/public/* (pre-auth) and
// /portal/v1/* (behind the portal auth middleware). It is the same engine client with the base
// URL suffixed by `/portal`, so `client.resource('tickets')` reaches /portal/v1/tickets and the
// staff API (/v1/*) is unreachable by construction — the guard test asserts exactly that.

export const PORTAL_PREFIX = '/portal';

export function createPortalClient(getToken: TokenProvider, opts: ClientOptions = {}): Client {
  const root = opts.baseUrl ?? ((import.meta.env?.VITE_API_URL as string | undefined) ?? '');
  return createClient(getToken, { ...opts, baseUrl: `${root}${PORTAL_PREFIX}` });
}

/** Absolute URL of a portal endpoint (for links the browser opens itself: print, download). */
export function portalUrl(client: Client, path: string): string {
  return `${client.baseUrl}${path}`;
}
